import axios from "axios";

const baseURL = `https://aqo35wclm7.execute-api.us-east-1.amazonaws.com/prod/v1`; // Production.
// const baseURL = `https://localhost:5001/v1` // Dev.

let authenticatorClient = axios.create({
  baseURL: baseURL,
  crossdomain: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

authenticatorClient.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default {
  addSubscriptionNoCC(email, password, product) {
    var headers = {
      headers: {
        email: email,
        password: password,
        product: product
      }
    };
    return authenticatorClient.post(
      "/subscriptions/addSubscriptionNoCC",
      {},
      headers
    );
  },

  addSubscriptionWithCC(
    email,
    product,
    firstNameOnCard,
    lastNameOnCard,
    ccNumber,
    cvv,
    expirationMonth,
    expirationYear
  ) {
    var headers = {
      headers: {
        email: email,
        product: product,
        firstNameOnCard: firstNameOnCard,
        lastNameOnCard: lastNameOnCard,
        ccNumber: ccNumber,
        cvv: cvv,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear
      }
    };
    return authenticatorClient.post(
      "/subscriptions/addSubscriptionWithCC",
      {},
      headers
    );
  },

  createSubscription(
    product,
    email,
    password,
    firstName,
    lastName,
    firstNameOnCard,
    lastNameOnCard,
    ccNumber,
    cvv,
    expirationMonth,
    expirationYear,
    trialPeriodDays = -1
  ) {
    var headers = {
      headers: {
        apiKey: "f1aa4012-2a62-4f6c-b50d-b38857239d01",
        product: product,
        email: email,
        password: password,
        firstName: firstName,
        lastName: lastName,
        firstNameOnCard: firstNameOnCard,
        lastNameOnCard: lastNameOnCard,
        ccNumber: ccNumber,
        cvv: cvv,
        expirationMonth: expirationMonth,
        expirationYear: expirationYear,
        trialPeriodDays: trialPeriodDays
      }
    };
    return authenticatorClient.post("/subscriptions", {}, headers);
  },

  async getVersion() {
    var url = `helpers/version`;
    return await authenticatorClient.get(url);
  },

  isMember(email) {
    var headers = {
      headers: {
        email: email
      }
    };
    return authenticatorClient.get("/subscriptions/isMember", headers);
  },

  productStatus(email, product) {
    var headers = {
      headers: {
        email: email,
        product: product
      }
    };
    return authenticatorClient.get("/subscriptions/status", headers);
  },

  reactivateProduct(email, password, product) {
    var headers = {
      headers: {
        email: email,
        password: password,
        product: product
      }
    };
    return authenticatorClient.put(
      "/subscriptions/reactivateProduct",
      {},
      headers
    );
  },

  resumeProduct(email, password, product) {
    var headers = {
      headers: {
        email: email,
        password: password,
        product: product
      }
    };
    return authenticatorClient.put("/subscriptions/resumeProduct", {}, headers);
  }
};
